module.exports = __webpack_public_path__ + "static/media/11.Foreign Tour.95773b63.JPG";